import type { ReactNode } from 'react';
import React from 'react';
import { useStyletron } from 'baseui';
import { GRID_Z_INDEX } from './constants';
type StickyLeftCellPropsT = {
  /** Fixed width in px (the row-header column width). */
  width: number;
  children: ReactNode;
};

/**
 * Fixed-width cell pinned to the left edge via CSS sticky, kept above the columns
 * in its row. Vertical pinning (for the corner) comes from the sticky header row.
 */
export const StickyLeftCell = ({
  width,
  children
}: StickyLeftCellPropsT) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    position: 'sticky',
    left: '0px',
    zIndex: GRID_Z_INDEX.pinnedCell,
    flexShrink: 0,
    width: `${width}px`,
    backgroundColor: theme.colors.backgroundPrimary
  })}>
      {children}
    </div>;
};